import { neutral } from '../Color';
import { css } from 'styled-components';
const getDarkCss = () => {
  return css(["color:white;background-color:#2d3942;border-color:#2d3942;&:hover,&.hover{background-color:#2d3942;}&:focus,&.focus{background-color:#2d3942;border-color:#2d3942;}&:active,&.active{background-color:#2d3942;border-color:#2d3942;}&:disabled,&.disabled{color:", ";border-color:", ";background-color:", ";}"], neutral.color6, neutral.color7, neutral.color9);
};
export default getDarkCss;